import { render } from "./CorpId.vue?vue&type=template&id=1a49b32a&scoped=true"
import script from "./CorpId.vue?vue&type=script&lang=js"
export * from "./CorpId.vue?vue&type=script&lang=js"

import "./CorpId.vue?vue&type=style&index=0&id=1a49b32a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a49b32a"]])

export default __exports__